import { camelCaseModifier } from "./CamelCaseModifier.function";
import { PascalToCamel } from "./types/PascalToCamel";

export async function fromPascalToCamel<T, R = PascalToCamel<T>>(response: Response): Promise<R> {
    return camelCaseModifier<T>(await response.text()) as R;
}
